import React from 'react';
import { useCart } from '../context/CartContext';
export function Sale() {
  const {
    addToCart
  } = useCart();
  const saleItems = [{
    image: 'https://cdn.magicpatterns.com/uploads/dswRZZ53UQGzxyozfVKUuy/image.png',
    name: 'Heritage Coral Set',
    originalPrice: '$450',
    salePrice: '$315'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/2nw7TL6DJ9kyaU7YdTprye/image.png',
    name: 'Vibrant Dashiki',
    originalPrice: '$180',
    salePrice: '$126'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/4TuYhr9Tv4eB59YELcYJQL/image.png',
    name: 'Embroidered Agbada',
    originalPrice: '$850',
    salePrice: '$595'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/dumL3rwAmxywUmvcQ1HoPe/image.png',
    name: 'Maroon Lace Ensemble',
    originalPrice: '$580',
    salePrice: '$406'
  }];
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-773">
      <div className="max-w-[1800px] mx-auto" data-id="element-774">
        <header className="mb-20 text-center" data-id="element-775">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-4 block text-red-600" data-id="element-776">
            Limited Opportunity
          </span>
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-777">
            Sale
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase px-4 md:px-0" data-id="element-778">
            Exclusive pieces from previous collections at exceptional value.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-779">
          {saleItems.map((item, i) => <div key={i} className="group" data-id="element-780">
              <div className="aspect-[3/4] bg-grey-divider overflow-hidden mb-4 relative" data-id="element-781">
                <div className="absolute top-4 left-4 bg-red-600 text-white text-xs font-display font-bold px-3 py-1.5 tracking-widest uppercase z-10" data-id="element-782">
                  30% OFF
                </div>
                <img src={item.image} alt={item.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-783" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-784">
                  <button onClick={() => addToCart({
                id: `sale-${item.name}`,
                name: item.name,
                price: item.salePrice,
                image: item.image,
                quantity: 1,
                size: 'OS'
              })} className="bg-white text-black px-6 py-3 text-xs font-display font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-785">
                    Add to Bag
                  </button>
                </div>
              </div>
              <div className="flex justify-between items-start" data-id="element-786">
                <div data-id="element-787">
                  <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase mb-1" data-id="element-788">
                    {item.name}
                  </h3>
                  <p className="text-sm font-light" data-id="element-789">
                    <span className="line-through text-black/30 mr-2" data-id="element-790">
                      {item.originalPrice}
                    </span>{' '}
                    <span className="text-black font-bold" data-id="element-791">
                      {item.salePrice}
                    </span>
                  </p>
                </div>
                <button onClick={() => addToCart({
              id: `sale-${item.name}`,
              name: item.name,
              price: item.salePrice,
              image: item.image,
              quantity: 1,
              size: 'OS'
            })} className="md:hidden text-xs font-display font-bold uppercase tracking-widest border-b border-black pb-0.5" data-id="element-792">
                  Add to Bag
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}